import { defineComponent as s, openBlock as i, createElementBlock as r, unref as o, normalizeClass as l, toDisplayString as p } from "vue";
import { usePagination as m } from "./index746.js";
import { paginationTotalProps as c } from "./index749.js";
import { useLocale as d } from "./index597.js";
import { useNamespace as f } from "./index559.js";
const _ = ["disabled"];
var C = /* @__PURE__ */ s({
  name: "ElPaginationTotal",
  __name: "total",
  props: c,
  setup(u) {
    const { t } = d(), a = f("pagination"), { disabled: e } = m();
    return (n, g) => (i(), r("span", {
      class: l(o(a).e("total")),
      disabled: o(e)
    }, p(o(t)("el.pagination.total", {
      total: n.total
    })), 11, _));
  }
});
export {
  C as default
};
